import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { axios } from '@/libraries/axios'

/* The /api/oauth/status answer only marks the session as signed in: the access token stays
 * in an httpOnly cookie the page never reads. */
export const useAuthStore = defineStore('auth', () => {
  const user = ref<object | null>(null)
  const isAuthenticated = computed(() => user.value !== null)

  async function checkAuth(): Promise<void> {
    try {
      const response = await axios.get<object>('/api/oauth/status')
      user.value = response.status === 200 && response.data ? response.data : null
    } catch {
      user.value = null
    }
  }

  function reset(): void {
    user.value = null
  }

  return { isAuthenticated, user, checkAuth, reset }
})
